// Copyright (C) 2017-2023 Smart code 203358507

const ToastItem = require('./ToastItem');

module.exports = ToastItem;
